import {
  defineMasterdataEntity,
  MasterdataFilter,
} from '../types/masterdata-entity-definition';
import { MasterdataCostCenter } from '../types/masterdata-entities';
import { ACTIVE_ONLY, keyName } from './shared';

const EXCLUDE_OBJECT_COST_CENTERS: MasterdataFilter = {
  type: 'booleanIsTrue',
  name: 'excludeObjectCostCenters',
};

export const MASTERDATA_COST_CENTER = defineMasterdataEntity<MasterdataCostCenter>({
  name: 'cost-center',
  responseKey: 'costCenters',
  displayWith: (c) => keyName(c.key, c.name),
  secondaryWith: (c) => c.description ?? c.name2,
  defaultFilter: [...ACTIVE_ONLY, EXCLUDE_OBJECT_COST_CENTERS],
  icon: 'fa-regular fa-chart-pie',
  title: 'Kostenstellensuche',
  label: 'Kostenstelle',
  placeholder: 'Kostenstelle suchen...',
  columns: [
    {
      label: 'Kostenstelle',
      type: 'entity',
      icon: 'fa-regular fa-chart-pie',
      value: (e) => keyName(e.key, e.name),
      secondary: (e) => e.description ?? e.name2,
    },
    { label: 'Schlüssel', value: (e) => e.key },
    { label: 'Bezeichnung', value: (e) => e.name },
    { label: 'Bezeichnung 2', value: (e) => e.name2 },
    { label: 'Beschreibung', value: (e) => e.description },
    { label: 'Kontenplan', value: (e) => e.chartOfAccounts },
    { label: 'Verantwortlich', value: (e) => e.responsible },
    { label: 'Gesperrt ab', value: (e) => e.lockedFrom },
    { label: 'Risikofaktor', value: (e) => e.calculatedRiskFactor },
    { label: 'Budget', value: (e) => e.budget },
    { label: 'Budget-Aktualisierung', value: (e) => e.budgetUpdate },
    { label: 'ERP-Nummer', value: (e) => e.erpNumber },
    { label: 'Kategorie', value: (e) => e.category },
    {
      label: 'Kostenrechnungskennzeichen',
      value: (e) => (e.allowCostAccountingIndicators ? 'Ja' : 'Nein'),
    },
    { label: 'Art', value: (e) => e.type?.name ?? null },
  ],
});
